import { render, staticRenderFns } from "./SpendBackStepEmail.vue?vue&type=template&id=5b24efc0&scoped=true"
import script from "./SpendBackStepEmail.vue?vue&type=script&lang=js"
export * from "./SpendBackStepEmail.vue?vue&type=script&lang=js"
import style0 from "./SpendBackStepEmail.vue?vue&type=style&index=0&id=5b24efc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b24efc0",
  null
  
)

export default component.exports